export default __webpack_public_path__ + "static/media/file-img.72124651.svg";